import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-96c93f28"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Monitoring Lists ");

var _hoisted_4 = {
  class: "high-text"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0,
  class: "text"
};
var _hoisted_7 = {
  class: "light-text"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("Registration Number: ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("Credit Social Code: ");

import { apiMonitorRecordList, apiMonitorDel } from '@/api/information';
import { onBeforeMount, ref } from 'vue';
import { headers } from './data';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var keywords = ref('');
    var subBtnLoading = ref(false);
    var tableData = ref([]);
    var tableRef = ref(null);
    var route = useRoute();
    onBeforeMount(function () {
      getData();
    });
    var tableLoading = ref(false);

    function getData() {
      tableLoading.value = true;
      apiMonitorRecordList().then(function (_ref) {
        var data = _ref.data;
        tableData.value = data || [];
      }).finally(function () {
        tableLoading.value = false;
      });
    }

    function handleDelete(_ref2) {
      var keyNo = _ref2.keyNo;
      apiMonitorDel({
        keyNo: keyNo
      }).then(function (_ref3) {
        var data = _ref3.data;
        ElMessage.success('cancel success!');
        getData();
      });
    }

    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      var _directive_copy = _resolveDirective("copy");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(tableData.value.length), 1)])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        },
        "empty-text": "No records found",
        "header-cell-style": {
          background: '#F5F5F7',
          paddingTop: '20px',
          paddingBottom: '20px'
        }
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), function (tabItem) {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: tabItem.key,
              prop: tabItem.key,
              label: tabItem.title,
              width: tabItem.width
            }, _createSlots({
              _: 2
            }, [tabItem.htmlDomFunc ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  innerHTML: tabItem.htmlDomFunc(scope.row)
                }, null, 8, _hoisted_5), tabItem.showNumber ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [scope.row.countryCode !== 86 ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_hoisted_8], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_hoisted_9], 64))]), _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(scope.row.entityNo), 1)])), [[_directive_copy, scope.row.entityNo]])])) : _createCommentVNode("", true)];
              })
            } : tabItem.title === 'Action' ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  class: "high-text--underline",
                  onClick: function onClick($event) {
                    return handleDelete(scope.row);
                  }
                }, "Cancel", 8, ["onClick"])];
              })
            } : undefined]), 1032, ["prop", "label", "width"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["data"])), [[_directive_loading, tableLoading.value]])]);
    };
  }
});